<template>
  <div class="container f-content" v-if="question.content  && question.id =='dx_28' ">
    <div class="first-half">
      <span v-if="question.sunscreenprice"><img class="fh2" style="float: left; width:24% " src="../../assets/images/Sunscreen50_black.png" alt="UV Index" > </span>

            </div>  
            <div class="second-half">
  
            <span class="f-section-text">Συγχαρητήρια! Ολοκλήρωσες επιτυχώς την 4η δοκιμασία και εξασφάλισες την αντηλιακή κρέμα. Μάζεψες <b> {{ question.totalpointshere }} νομίσματα </b>  ως τώρα και μπορείς να μαζέψεις ακόμη περισσότερα με το τελικό κουιζ!</span>
            </div>
  </div>          
  <div class="container f-content" v-if="question.content  && question.correct ==0 && question.id !='dx_28'">
    <div class="first-half">
                <span v-if="question.hero"><img class="fh2" style="float: left;" src="../../assets/images/sunhero.png" alt="Hero" ></span>
                <span v-if="question.scientist"><img class="fh2" style="float: left;" src="../../assets/images/scientist.png" alt="Scientist" ></span>
                <span v-if="question.uvindex"><img class="fh2" style="float: left;" src="../../assets/images/uvindex.png" alt="UV Index" > </span>
                <span v-if="question.granny"><img class="fh2" style="float: left;" src="../../assets/images/granny.png" alt="Grany" > </span>
                <span v-if="question.glassdoc"><img class="fh2" style="float: left;" src="../../assets/images/ofthalmiatros.png" alt="Glass Doctor" > </span>
                <span v-if="question.dermatologist"><img class="fh2" style="float: left; width:36%" src="../../assets/images/dermatologist.png" alt="Dermatologist Doctor" > </span>
                <span v-if="question.sun1"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure1.png" alt="UV Index" > </span>
                <span v-if="question.sun2"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure2.png" alt="UV Index" > </span>
                <span v-if="question.sun3"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure3.png" alt="UV Index" > </span>
                <span v-if="question.sun4"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure4.png" alt="UV Index" > </span>
                <span v-if="question.uvmeterbar"><img class="fh2" style="float: left; width:100% " src="../../assets/images/HowToUse.png" alt="UV Index" > </span>
                <span v-if="question.roundhat"><img class="fh2" style="float: left; width:46% " src="../../assets/images/roundhat.png" alt="UV Index" > </span>
                <span v-if="question.glassprice"><img class="fh2" style="float: left; width:46% " src="../../assets/images/glasses.png" alt="UV Index" > </span>
                <span v-if="question.sunscreenprice"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunscreen50_black.png" alt="UV Index" > </span>

            
            </div>  
            <div class="second-half">
  
            <span class="f-section-text">{{ question.content }}</span>
            </div>
  </div>
  <div class="container f-content" v-else-if="question.content && question.correct ==1 && question.id !='dx_28'">
    <div class="first-half">
                <span v-if="question.hero"><img class="fh2" style="float: left;" src="../../assets/images/sunhero.png" alt="Hero" ></span>
                <span v-if="question.scientist"><img class="fh2" style="float: left;" src="../../assets/images/scientist.png" alt="Scientist" ></span>
                <span v-if="question.uvindex"><img class="fh2" style="float: left;" src="../../assets/images/uvindex.png" alt="UV Index" > </span>
                <span v-if="question.granny"><img class="fh2" style="float: left;" src="../../assets/images/granny.png" alt="Grany" > </span>
                <span v-if="question.glassdoc"><img class="fh2" style="float: left;" src="../../assets/images/ofthalmiatros.png" alt="Glass Doctor" > </span>
                <span v-if="question.dermatologist"><img class="fh2" style="float: left; width:36%" src="../../assets/images/dermatologist.png" alt="Dermatologist Doctor" > </span>
                <span v-if="question.sun1"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure1.png" alt="UV Index" > </span>
                <span v-if="question.sun2"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure2.png" alt="UV Index" > </span>
                <span v-if="question.sun3"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure3.png" alt="UV Index" > </span>
                <span v-if="question.sun4"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure4.png" alt="UV Index" > </span>
                <span v-if="question.uvmeterbar"><img class="fh2" style="float: left; width:100% " src="../../assets/images/HowToUse.png" alt="UV Index" > </span>
                <span v-if="question.roundhat"><img class="fh2" style="float: left; width:46% " src="../../assets/images/roundhat.png" alt="UV Index" > </span>
                <span v-if="question.glassprice"><img class="fh2" style="float: left; width:46% " src="../../assets/images/glasses.png" alt="UV Index" > </span>
                <span v-if="question.sunscreenprice"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunscreen50_black.png" alt="UV Index" > </span>

               
            </div>
            <div class="second-half">

          <span class="f-section-text"><SpeechBubble :correct=false>{{ question.content }}</SpeechBubble></span>
            </div>
  </div>

  <div class="container f-content" v-else-if="question.content && question.correct ==2 && question.id !='dx_28'">
    <div class="first-half">
                <span v-if="question.hero"><img class="fh2" style="float: left;" src="../../assets/images/sunhero.png" alt="Hero" ></span>
                <span v-if="question.scientist"><img class="fh2" style="float: left; width:37%" src="../../assets/images/scientist.png" alt="Scientist" ></span>
                <span v-if="question.uvindex"><img class="fh2" style="float: left;" src="../../assets/images/uvindex.png" alt="UV Index" > </span>
                <span v-if="question.granny"><img class="fh2" style="float: left;" src="../../assets/images/granny.png" alt="Grany" > </span>
                <span v-if="question.glassdoc"><img class="fh2" style="float: left; " src="../../assets/images/ofthalmiatros.png" alt="Glass Doctor" > </span>
                <span v-if="question.dermatologist"><img class="fh2" style="float: left; width:36%" src="../../assets/images/dermatologist.png" alt="Dermatologist Doctor" > </span>
                <span v-if="question.sun1"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure1.png" alt="UV Index" > </span>
                <span v-if="question.sun2"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure2.png" alt="UV Index" > </span>
                <span v-if="question.sun3"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure3.png" alt="UV Index" > </span>
                <span v-if="question.sun4"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunmeasure4.png" alt="UV Index" > </span>
                <span v-if="question.uvmeterbar"><img class="fh2" style="float: left; width:100% " src="../../assets/images/HowToUse.png" alt="UV Index" > </span>
                <span v-if="question.roundhat"><img class="fh2" style="float: left; width:46% " src="../../assets/images/roundhat.png" alt="UV Index" > </span>
                <span v-if="question.glassprice"><img class="fh2" style="float: left; width:46% " src="../../assets/images/glasses.png" alt="UV Index" > </span>
                <span v-if="question.sunscreenprice"><img class="fh2" style="float: left; width:46% " src="../../assets/images/Sunscreen50_black.png" alt="UV Index" > </span>

                
  
</div>
    <div class="second-half">
        <span class="f-section-text"><SpeechBubble :correct=true>{{ question.content }}</SpeechBubble></span>
      </div>
  </div>


</template>

<script>
  /*
    Copyright (c) 2020 - present, DITDOT Ltd. - MIT Licence
    https://github.com/ditdot-dev/vue-flow-form
    https://www.ditdot.hr/en
  */
  import SpeechBubble from '../SpeechBubble.vue';
  import BaseType from './BaseType.vue'
  import { QuestionType } from '../../models/QuestionModel'
  import LanguageModel from '../../models/LanguageModel'

  export default {
    extends: BaseType,
    components:{SpeechBubble},
    name: QuestionType.SectionBreak,
    methods: {
      onEnter() {
        this.dirty = true

        this._onEnter()
      },

      isValid() {
        return true
      }
    }
  }
</script>